<!-- DIY模板 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.name" clearable placeholder="请输入模板名称"></Input>
            <Button class="theme-bg mb-24" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal(1)">新增模板</Button>
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="success" ghost label="small" @click="goModal(1, row)">编辑</Button>
                        <Button type="primary" ghost label="small" @click="goManage(row)">管理</Button>
                        <Button class="btn_copy" @click="goCopy(row)">复制</Button>
                        <Button type="error" ghost label="small" @click="goDel(1, row)">删除</Button>
                    </div>
                </template>
            </Table>
            <div class="ta-r mt-24">
                <Page :current="storePrams.page" :total="total" :page-size="storePrams.limit" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 复制模板 -->
        <Modal v-model="copyModal" title="复制模板" width="500" :mask-closable="false">
            <div>
                <Form :model="formItem" label-position="right" :label-width="100">
                    <FormItem label="模板名称">
                        <Input type="text" v-model="formItem.title" placeholder="请输入模板名称"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelCopyModal">取消</Button>
                <Button  class="theme-bg" type="warning" @click="submitCopyModal">确定</Button>
            </div>
        </Modal>
        <!-- 模板管理 -->
        <Modal v-model="manageModal" title="模板管理" width="50" :mask-closable="false">
            <div>
                <Button class="theme-bg mb-24" icon="md-add-circle" type="warning" @click="goModal(2)">新增页面</Button>
                <Table :columns="columnManage" :data="dataManage" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <div class="width_90">
                                <Button v-if="row.is_index != 1" type="success" ghost label="small" @click="setHome(row)">设为首页</Button>
                            </div>
                            <Button type="primary" ghost label="small" @click="goModal(2, row)">编辑</Button>
                            <Button type="error" ghost label="small" @click="goDel(2, row)">删除</Button>
                        </div>
                    </template>
                </Table>
                <div class="ta-r mt-24">
                    <Page :current="storePramsManage.page" :page-size="storePramsManage.limit" :total="totalManage" show-elevator show-total @on-change="pageChangeManage"/>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增模板/编辑模板 -->
        <Modal v-model="modals" :title="modalTitle" width="500" :mask-closable="false">
            <div>
                <Form :model="formItem" label-position="right" :label-width="100">
                    <FormItem label="模板名称">
                        <Input type="text" v-model="formItem.title" placeholder="请输入模板名称"></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bg" type="warning" @click="submitModal">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    template_diy_list, 
    template_diy_copy, 
    template_diy_manage, 
    template_diy_del, 
    template_diy_save, 
    template_diy_del_manage, 
    template_diy_set,
} from '@/api/index';
import VueQr from 'vue-qr'
export default {
    components: { VueQr },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
            },
            total: 0,
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "创建时间", key: "created_at", align: "center", width: "200px" },
                { title: "操作", slot: "operate", align: "center", width: "400px" },
            ],
            dataTable: [],
            storePramsManage: {
                page: 1,
                limit: 10,
                id: '',
            },
            totalManage: 0,
            columnManage: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "页面名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataManage: [],
            copyModal: false,
            manageModal: false,
            modals: false,
            modalTitle: "",
            // VueQr
            vueqr_text: "",
            manageData: {
                id: "",
                diy_template_id: "",
                title: "",
            },
            formItem: { 
                title: "",
                id: "",
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        getList() {
            template_diy_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // Page @on-change
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeManage(index) {
            this.storePramsManage.page = index;
            this.getManageList();
        },
        // 设置默认首页
        setHome(row){
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: '确认设置默认首页为（'+ row.title +'）吗？',
                onOk: () => {
                    template_diy_set({ id: row.id }).then((res) => {
                        that.getManageList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                },
                onCancel: () => {
                },
            });
        },
        // DIY模板管理列表
        getManageList() {
            template_diy_manage(this.storePramsManage).then((res) => {
                this.dataManage = res.data.data;
                this.totalManage = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 删除
        goDel(index, row) {
            let that = this;
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if(index == 1){
                        template_diy_del({ id: row.id }).then((res) => {
                            that.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }else if(index == 2){
                        template_diy_del_manage({ id: row.id }).then((res) => {
                            that.getManageList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    }
                },
                onCancel: () => {
                },
            });
        },
        goCopy(row) {
            this.formItem.title = row.title;
            this.formItem.id = row.id;
            this.copyModal = true;
        },
        goManage(row){
            this.storePramsManage.id = row.id;
            this.manageData.diy_template_id = row.id;
            this.getManageList();
            this.manageModal = true;
        },
        goModal(index, row) {
            if(index == 1){
                if(row){
                    this.modalTitle = "编辑模板";
                    this.formItem.title = row.title;
                    this.formItem.id = row.id;
                }else{
                    this.modalTitle = "新增模板";
                    this.formItem.id = "";
                    this.formItem.title = "";
                }
                this.modals = true;
            }else if(index == 2){
                if(row){
                    this.manageData.id = row.id;
                    this.manageData.title = row.title;
                }else{
                    this.manageData.id = "";
                    this.manageData.title = "";
                }
                setTimeout(() => {
                    // 跳转DIY
                    // diy_id == 1（产品模板）
                    this.$router.push({ path: `/admin/formwork/editDiy?id=${this.manageData.id}&diy_template_id=${this.manageData.diy_template_id}&diy_id=1` });
                }, 500);
            }
        },
        // 取消
        cancelCopyModal() {
            this.copyModal = false;
        },
        // 确定
        submitCopyModal() {
            template_diy_copy(this.formItem).then((res) => {
                this.getList();
                this.copyModal = false;
                this.$Message.success(res.msg);
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 取消
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            template_diy_save(this.formItem).then((res) => {
                this.getList();
                this.modals = false;
                this.$Message.success(res.msg);
            })
            .catch((res) => {
                this.$Message.error(res.msg);
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-family: Source Han Sans CN;
    font-size: 14px;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.btn_copy {
    border: 1px solid #6C52FF;
    color: #6C52FF;
}
.width_90 {
    width: 90px;
}
::v-deep .ivu-form-item {
    margin-bottom: 0;
}
</style>